import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate, Navigate } from "react-router-dom";
import { Layout, Menu, Button, ConfigProvider, theme } from "antd";
import {
    SearchOutlined,
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    NotificationOutlined,
    ReadOutlined,
    InfoCircleOutlined
} from "@ant-design/icons";

// 頁面引入
import Query from "./pages/Query";
import News from "./pages/News";
import Medical from "./pages/Medical";
import Guideline from "./pages/Guideline"; // 新增頁面

const { Sider, Header, Content } = Layout;

const App: React.FC = () => {
    const [collapsed, setCollapsed] = useState(window.innerWidth < 768);

    return (
        <Router>
            <ConfigProvider
                theme={{
                    algorithm: theme.defaultAlgorithm,
                    token: {
                        colorPrimary: "#1677ff",
                        borderRadius: 8,
                        colorBgLayout: "#f5f5f5",
                        colorText: "#333",
                        colorBorder: "#d9d9d9",
                        fontSize: 16,
                    },
                }}
            >
                <Layout style={{ minHeight: "100vh" }}>
                    <SiderComponent collapsed={collapsed} setCollapsed={setCollapsed} />
                    <Layout>
                        <HeaderComponent collapsed={collapsed} setCollapsed={setCollapsed} />
                        <Content style={{ margin: "24px 16px", padding: 24, background: "#fff", minHeight: 280 }}>
                            <Routes>
                                <Route path="/query" element={<Query />} />
                                <Route path="/news" element={<News />} />
                                <Route path="/medical" element={<Medical />} />
                                <Route path="/guideline" element={<Guideline />} />
                                <Route path="*" element={<Navigate to="/query" replace />} />
                            </Routes>
                        </Content>
                    </Layout>
                </Layout>
            </ConfigProvider>
        </Router>
    );
};

// 側邊選單組件
const SiderComponent: React.FC<{
    collapsed: boolean;
    setCollapsed: React.Dispatch<React.SetStateAction<boolean>>
}> = ({ collapsed, setCollapsed }) => {
    const navigate = useNavigate();

    return (
        <Sider
            width={220}
            collapsible
            collapsed={collapsed}
            onCollapse={(value) => setCollapsed(value)}
            theme="light"
            style={{ display: "flex", flexDirection: "column" }}
        >
            <div style={{ height: 64, background: "#1890ff", textAlign: "center", color: "#fff", lineHeight: "64px", fontSize: 18, fontWeight: "bold" }}>
                {collapsed ? "🐾" : "功能選單"}
            </div>

            <div style={{ flexGrow: 1, overflowY: "auto" }}>
                <Menu mode="inline" defaultSelectedKeys={["/query"]} theme="light" onClick={({ key }) => navigate(key)}>
                    <Menu.Item key="/news" icon={<NotificationOutlined />}>公告</Menu.Item>
                    <Menu.Item key="/query" icon={<SearchOutlined />}>查詢</Menu.Item>
                    <Menu.Item key="/medical" icon={<ReadOutlined />}>醫療科普</Menu.Item>
                    <Menu.Item key="/guideline" icon={<InfoCircleOutlined />}>飼育指南</Menu.Item>
                </Menu>
            </div>
        </Sider>
    );
};

// 頂部導覽列組件
const HeaderComponent: React.FC<{
    collapsed: boolean;
    setCollapsed: React.Dispatch<React.SetStateAction<boolean>>
}> = ({ collapsed, setCollapsed }) => {
    return (
        <Header style={{ padding: "0 20px", background: "#fff", height: 64, display: "flex", alignItems: "center", boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)" }}>
            <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={() => setCollapsed(!collapsed)}
                style={{ fontSize: "20px", color: "#333" }}
            />
        </Header>
    );
};

export default App;